import { InjectionToken } from '@angular/core';

export const ERROR_MESSAGES_MAP = {
  email: 'Formato incorrecto de email',
  required: 'Campo obligatorio',
  pattern: 'Formato incorrecto',
  numbersOnly: 'Número inválido',
  alphaSpace: 'Sólo letras y espacios',
  minlength: 'El campo es muy corto',
  wrongCountry: 'País no soportado',
  wrongPhoneFormat: 'Formato teléfono incorrecto para el país seleccionado',
  maxLength: 'El campo superó su máximo de caracteres',
  postalCode: 'Código postal inválido',
  strictEmail: 'El correo ingresado no es válido'
};

export const ERROR_MESSAGE_MAP_TOKEN = new InjectionToken<typeof ERROR_MESSAGES_MAP>('ERROR_MESSAGE_MAP');
